module.exports = __webpack_public_path__ + "media/images/badges/yogasix/february/HeartBadges-11-86cc6202865b692c0076090b9dfd2580.png";